export default {"src":"/_next/static/media/business4.4ad446b5.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};